import { render, staticRenderFns } from "./dialog-motivo-indeferimento.vue?vue&type=template&id=11131664&scoped=true"
import script from "./dialog-motivo-indeferimento.vue?vue&type=script&lang=js"
export * from "./dialog-motivo-indeferimento.vue?vue&type=script&lang=js"
import style0 from "./dialog-motivo-indeferimento.vue?vue&type=style&index=0&id=11131664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11131664",
  null
  
)

export default component.exports